export const GET_ALL_CUSTOM_SKELETONS = "GET_ALL_CUSTOM_SKELETONS"
export const GET_ALL_CUSTOM_SKELETONS_SUCCESS = "GET_ALL_CUSTOM_SKELETONS_SUCCESS"

export const GET_CUSTOM_SKELETON_BY_ID = "GET_CUSTOM_SKELETON_BY_ID"
export const GET_CUSTOM_SKELETON_BY_ID_SUCCESS = "GET_CUSTOM_SKELETON_BY_ID_SUCCESS"

export const RESET_ACTUAL_CUSTOM_SKELETON = "RESET_ACTUAL_CUSTOM_SKELETON"

export const GET_SKELETON_DEFAULT_FIELDS = "GET_SKELETON_DEFAULT_FIELDS"
export const GET_SKELETON_DEFAULT_FIELDS_SUCCESS = "GET_SKELETON_DEFAULT_FIELDS_SUCCESS"

export const POST_CUSTOM_SKELETON = "POST_CUSTOM_SKELETON"
export const PATCH_CUSTOM_SKELETON = "PATCH_CUSTOM_SKELETON"
export const DELETE_CUSTOM_SKELETON = "DELETE_CUSTOM_SKELETON"
